<div>
    <div class="h3 red">{{'company_choose_new_company_headline' | i18next}}</div>

    <app-company-form [company]="company"
                      [countries]="countries"
                      submitButtonLabel="company_choose_new_company_save_btn"
                      (formSubmit)="onCreate($event)"
                      [showInvoiceMail]="false"
                      [showElectronicInvoiceMail]="false"
                      [showVat]="false"
    ></app-company-form>
</div>
